import { Media } from "../common";
import { StatusInfo } from "../common/Status";
import type { ProductSizeGuidePayload } from "../sizeGuide/types";
import { ProductCategory } from "../productCategory";

/**
 * Entidad Product
 * Representa un producto vendible en la tienda. Es la entidad base que puede tener múltiples variantes.
 */

export interface Product {
  id: string;
  accountId: string;
  code: string;
  brandId?: string | null;
  supplierId?: string | null;
  /** When set, storefront uses this size guide instead of category rules. */
  sizeGuideId?: string | null;
  productType: ProductType;
  sku?: string | null;
  barcode?: string | null;
  name: string;  // e.g., "Zapatos", "Pantalones", "Camisas"
  slug: string;
  description?: string | null;
  isFeatured: boolean;

  // Inventory & Shipping
  allowBackorder: boolean;  // Permite realizar pedidos aunque no haya stock disponible. Se aplica a las variantes si no está definido allí
  weight?: number | null;
  weightUnit?: string | null; // e.g., "kg"
  height?: number | null;
  width?: number | null;
  depth?: number | null; 
  dimensionUnit?: string | null; // e.g., "cm"
  shippingLeadTime?: string | null;  // e.g., "1-3 days"

  status: ProductStatus; // ACTIVE, INACTIVE
  statusInfo?: StatusInfo;
  
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  media?: Media[]

  variants?: ProductVariant[];
  categories?: ProductCategory[];

  /** Present on storefront product detail after server-side resolution. */
  sizeGuide?: ProductSizeGuidePayload | null;
}

export enum ProductStatus {
  ACTIVE = 'ACTIVE', // Available for sale
  INACTIVE = 'INACTIVE', // Not visible/purchasable
  ARCHIVED = 'ARCHIVED', // Not visible, kept for records
  DRAFT = 'DRAFT', // Incomplete product setup
}

export enum ProductType {
    SIMPLE = 'SIMPLE', // Product without variants (may have a default hidden variant)
    VARIABLE = 'VARIABLE', // Product with distinct variants (color, size, etc.)
    BUNDLE = 'BUNDLE', // A package of other products/variants
    GIFT_CARD = 'GIFT_CARD', // Virtual or physical gift card
}


export interface ProductVariant {
  id: string;
  accountId: string;
  productId: string;

  sku?: string | null;
  barcode?: string | null; // EAN, UPC, etc.

  // Pricing
  currency: string; // ISO 4217 currency code
  price: number;
  compareAtPrice?: number;
  allowBackorder?: boolean;
  
  // Inventory & Shipping
  stock: number;
  status: ProductVariantStatus;
  weight?: number | null;
  weightUnit?: string | null;
  height?: number | null;
  width?: number | null;
  depth?: number | null;
  dimensionUnit?: string | null;
  shippingLeadTime?: string | null; // e.g., "1-3 days"
  
  order: number;

  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;

}

export enum ProductVariantStatus {
  ACTIVE = 'ACTIVE',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  COMING_SOON = 'COMING_SOON',
}